$(document).ready(function () {
  const slickSLiders = $(".heirloom__slider--stacking");
  const pdpTabslider = $(".heirloom__slider--tab");

  pdpTabslider.each(function (item, value) {
    let nextArrow = $(value).siblings().find(".next-link");
    let prevArrow = $(value).siblings().find(".previous-link");
    $(value).slick({
      slidesToShow: 3.4,
      slidesToScroll: 1,
      infinite: false,
      nextArrow: nextArrow,
      prevArrow: prevArrow,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2.2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1.1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  slickSLiders.each(function (item, value) {
    let nextArrow = $(value).siblings().find(".next-link");
    let prevArrow = $(value).siblings().find(".previous-link");

    $(value).slick({
      slidesToShow: 3.5,
      slidesToScroll: 1,
      infinite: false,
      nextArrow: nextArrow,
      prevArrow: prevArrow,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2.7,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1.1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
});
